import URL from "url-parse";

import Config from "./config";
import Logger from "../logic/util/Logger";
import ConfigModel from "../logic/model/ConfigModel";
import appStore from "../logic/store/AppStore";

let env =
  Config.env ||
  (!process.env.NODE_ENV || process.env.NODE_ENV === "development"
    ? "dev"
    : "live");

let publicUrl = new URL(Config[env].url).origin;

let common = {
  resetDB: false,
  disablePasscode: false,
  forceIntros: false,
  publicUrl: publicUrl,
  passcodeLength: 6,
  cardRatio: 1.56,
  physicalCardCost: 7.5,
  maxTopUpValue: 250,
  minTopUpValue: 10,
  support: {
    phone: "0113 320 1900"
  }
};

let configuration = {
  dev: {
    ...common,
    checkout_url: "https://sandbox.checkout.com/api2/v2/tokens/card",
    checkout_public_key: "pk_test_24166a6e-18f7-4405-b42a-d74aa75dc05d",
    ...Config.dev
  },
  live: {
    ...common,
    checkout_url: "https://sandbox.checkout.com/api2/v2/tokens/card",
    checkout_public_key: "pk_test_24166a6e-18f7-4405-b42a-d74aa75dc05d",
    ...Config.live
  }
};

const config = {
  env,

  // Preloaded configuration
  ...configuration[env],

  cards: {
    cardPrice: {
      GBP: 10
    }
  },
  topUp: {
    min: 10,
    max: 200
  },

  facebook: {},
  twitter: {},
  linkedin: {},
  legalNotice: `
  <p>
  <Trans>
    'OnePay' is a trading name of Modus UK Limited, a company
    registered in England and Wales (No 05934955). Registered
    address: Mayfield House, Lower Railway Road, Ilkley, West
    Yorkshire, LS29 8FL.
  </Trans>
  </p>
  <p>
  <Trans>
    The OnePay Card is issued by PSI-Pay Ltd pursuant to a license
    by Mastercard® International Inc. Funds held within the OnePay
    account are issued by PSI-Pay Ltd, authorised and regulated by
    the Financial Conduct Authority of the United Kingdom under the
    Electronic Money Regulations 2011 (FRN 900011) for the issuing
    of electronic money.
  </Trans>
  </p>
  <p>
  <Trans>
    Access to payments including FPS, BACS, CHAPS and associated
    electronic money accounts are provided by Modulr FS Limited.
    Modus UK Limited is a registered EMD agent of Modulr FS Limited,
    a company of Modulr FS Limited, a company registered in England
    and Wales with company number 09897919, which is authorised and
    regulated by the Financial Conduct Authority as an Electronic
    Money Institution (Firm Reference Number: 900573) for the
    issuance of electronic money and payment services. Whilst
    Electronic Money products are not covered by the Financial
    Services Compensation Scheme (FSCS) funds will be held in one or
    more segregated accounts and safeguarded in line with the
    Electronic Money Regulations 2011 -
  </Trans>
  <a
    target="_blank"
    style={{ color: "#ea9600" }}
    href="https://9099838.fs1.hubspotusercontent-na1.net/hubfs/9099838/Modulr%20(MFSL)%20-%20UK%20Safeguarding%20Explanation%20-%20Jun%202021.pdf"
  >
    <Trans>for more information please see here. </Trans>
  </a>
  </p>
  <p>
  <Trans>
    Mastercard is a registered trademark, and the circles design is
    a trademark of Mastercard International Incorporated.
  </Trans>
  </p>
  <p>
  <Trans>
    Using the OnePay card and account is subject to our terms &
    conditions that can be viewed and downloaded at
  </Trans>
  <a
    target="_blank"
    style={{ color: "#ea9600" }}
    href="https://www.onepay.co.uk/terms-conditions"
  >
    https://www.onepay.co.uk/terms-conditions
  </a>
  .
  </p>
  </div>
  <p style={{ fontSize: 14 }}>
    <Trans>
    The OnePay app is only supported by selected devices running on
    iOS 12.0 and above or Android 5.0 and above. OnePay does not
    charge you for using the OnePay app, however your mobile operator
    may charge you to access the app. Access and usage may be
    restricted by signal limitations. Apple is a trademark of Apple
    Inc, registered in the U.S. and other countries. App Store is a
    service mark of Apple Inc. Android/Google Play is a trademark of
    Google Inc.
    </Trans>
  </p>
  `,
  /**
   * Load configuration, first from db, then from API
   */
  async load() {
    try {
      // Load from network
      await this.loadFromNetwork();
    } catch (e) {
      Logger.log("Config Load Error", e);
    }
  },

  /**
   * Load from network
   */
  async loadFromNetwork() {
    // Get from network
    let result = await new ConfigModel().fetch();

    if (result) {
      // Merge
      this.merge(result);
    }
  },

  /**
   * Merge data with current object
   *
   * @param {Object} result
   */
  async merge(result) {
    Object.assign(this, result);
    new ConfigModel().dispatchConfigUpdate(this);
  }
};

export default config;



// WEBPACK FOOTER //
// ./src/config/index.js